import { emptyObj } from '@beef/utils';

import type { RootState } from 'pages/MainPage/types';

export const selectHelpBlockDataForMetric = (state?: RootState) => state || (emptyObj as RootState);
